import * as React from 'react';

const MongoDBIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height="28" viewBox="0 0 14 28" width="28" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M7.61913 28L6.86813 27.751C6.86813 27.751 6.96813 23.951 5.59313 23.684C4.69313 22.636 5.72613 -21.057 9.01613 23.535C8.39191 23.8516 7.91428 24.3973 7.68313 25.058C7.55924 26.0338 7.53779 27.0198 7.61913 28Z"
            fill="url(#paint0_linear_781_1122)"
        />
        <path
            d="M8.02513 24.329C10.0247 22.8238 11.556 20.782 12.4411 18.4409C13.3262 16.0998 13.5287 13.5556 13.0251 11.104C11.5551 4.619 8.07413 2.487 7.69913 1.673C7.37559 1.16613 7.09942 0.630534 6.87413 0.073L7.15113 18.142C7.15113 18.142 6.57713 23.664 8.02513 24.329Z"
            fill="url(#paint1_linear_781_1122)"
        />
        <path
            d="M6.48613 24.569C6.48613 24.569 0.365129 20.4 0.719129 13.025C0.752152 10.8016 1.26193 8.61127 2.21404 6.60182C3.16615 4.59237 4.53841 2.81065 6.23813 1.377C6.43676 1.20825 6.59457 0.996676 6.6997 0.758181C6.80483 0.519686 6.85455 0.260468 6.84513 0C7.22613 0.82 7.16413 12.243 7.20413 13.579C7.35913 18.776 6.91513 23.588 6.48613 24.569Z"
            fill="url(#paint2_linear_781_1122)"
        />
        <defs>
            <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint0_linear_781_1122"
                x1="-8.44253"
                x2="7.77998"
                y1="12.2751"
                y2="28.5072"
            >
                <stop offset="0.231" stopColor="#999875" />
                <stop offset="0.563" stopColor="#9B9977" />
                <stop offset="0.683" stopColor="#A09F7E" />
                <stop offset="0.768" stopColor="#A9A889" />
                <stop offset="0.837" stopColor="#B7B69A" />
                <stop offset="0.896" stopColor="#C9C7B0" />
                <stop offset="0.948" stopColor="#DEDDCB" />
                <stop offset="0.994" stopColor="#F8F6EB" />
                <stop offset="1" stopColor="#FBF9EF" />
            </linearGradient>
            <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint1_linear_781_1122"
                x1="-1.52715"
                x2="1.10923"
                y1="-0.149043"
                y2="27.8149"
            >
                <stop stopColor="#48A547" />
                <stop offset="1" stopColor="#3F9143" />
            </linearGradient>
            <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint2_linear_781_1122"
                x1="0.192601"
                x2="10.4332"
                y1="13.755"
                y2="10.3254"
            >
                <stop stopColor="#41A247" />
                <stop offset="0.352" stopColor="#4BA74B" />
                <stop offset="0.956" stopColor="#67B554" />
                <stop offset="1" stopColor="#69B655" />
            </linearGradient>
        </defs>
    </svg>
);

export default MongoDBIcon;
